export default __webpack_public_path__ + "static/personal_atmosphere-bd3f5e260177896c3e988e942b71b475.png";